import { Field, ErrorMessage } from 'formik';
import { cn } from '@/utils/cn';

interface SelectProps {
  name: string;
  options: { value: string; label: string }[];
  placeholder?: string;
  label?: string;
  className?: string;
  required?: boolean;
  multiple?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select = ({
  name,
  options,
  placeholder,
  label,
  className,
  required,
  multiple = false,
  onChange,
}: SelectProps) => {
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={name} className="block text-sm text-gray-600 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <Field name={name}>
        {({ field, form }: any) => (
          <select
            id={name}
            {...field}
            multiple={multiple}
            onChange={(e) => {
              if (multiple) {
                // Handle multiple selection
                const selectedValues = Array.from(
                  e.target.selectedOptions,
                  (option: any) => option.value
                );
                form.setFieldValue(name, selectedValues);
              } else {
                // Handle single selection
                field.onChange(e);
              }
              // Then call any external handler
              if (onChange) onChange(e as React.ChangeEvent<HTMLSelectElement>);
            }}
            className={cn(
              'w-full border border-gray-300 rounded-md px-3 py-2 text-sm outline-none focus:outline-none focus:border-primary-500',
              multiple && 'min-h-[100px]',
              className
            )}
          >
            {placeholder && !multiple && (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}
      </Field>
      <ErrorMessage name={name} component="div" className="text-red-500 text-xs mt-1" />
    </div>
  );
};

export default Select;
